import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { GREY_LIGHTER_COLOR, TEXT_GREY } from '@CSSVars/colors'

export const _DropdownUl = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 155px;
  overflow-y: scroll;
  top: 80px;
  padding: 0;
  margin :0;
  background: white;
  border: 1px solid ${GREY_LIGHTER_COLOR};
  display: ${({ show }) => (show ? 'block' : 'none')};
  z-index: 100;
  border-radius: 10px;
  li {
    text-align: right;
    list-style: none;
    width: 100%;
    padding: 12px 10px;
    color: ${TEXT_GREY};
    border-bottom: 1px solid ${GREY_LIGHTER_COLOR};
    &:hover {
      cursor: pointer;
      font-weight: 500;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
  ${({ top }) => (top && 'top: -122px')};
  ${({ withTitle }) => (withTitle && `
    width: 90%;
    top: -144px;
    @media screen and (max-width: 47.9em)  {
      width: calc(100% - 1rem);
    }
  `)};
  @media screen and (max-width: 767px)  {
    max-height: 220px;
  }
`

export const _ArrowContainer = styled.div`
  position: absolute;
  width: 83px;
  ${({ showBorder }) => (showBorder && ' border-left: 1px solid #D7D7D7;')};
  bottom: 0;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-right: 16px;
  }
  &:before {
    content: '' !important;
   }
  &:hover {
     cursor: pointer;
   }
   svg {
     margin-bottom: 2px;
     padding-left: 2px;
   }
   height: ${({ resultType }) => (resultType ? '35' : 50)}px;
`
export const _Title = styled.div`
  padding: 0;

`
export const _WithTitleContainer = styled.div`
  width: auto;
  display: flex;
  position: relative;
  margin-top: 1.33rem;
  svg {
    top: 0;
  }
  @media screen and (max-width: 47.9em)  {
    span {
      font-size: 0.7rem;
    }
  }
  ${_ArrowContainer} {
    padding: 0;
    height: auto;
    width: auto;
    position: absolute;
    right: 0;
    top: 0;
  }

`
export const _CurrentVal = styled.span`
  margin-right: 0.25rem;
  color: ${TEXT_GREY};

`
